import React from "react";
import { Link } from "react-router-dom";
import { Check, ArrowRight } from "lucide-react";
import { aboutValues, aboutImages } from "../mock/mock";
import { Eyebrow } from "./SectionHeading";
import SmartImage from "./SmartImage";

export default function About() {
  return (
    <section id="about" className="relative overflow-hidden py-24 lg:py-32" style={{ background: "var(--sand)" }}>
      <div className="mx-auto grid max-w-[1280px] items-center gap-16 px-5 lg:grid-cols-2 lg:gap-20 lg:px-6">
        {/* Images */}
        <div className="relative" data-reveal="">
          <div className="overflow-hidden rounded-[1.5rem]" style={{ boxShadow: "0 40px 80px -50px rgba(8,46,41,.6)" }}>
            <SmartImage
              src={aboutImages.primary}
              fallback={aboutImages.primaryFallback}
              alt="Students at The KPR Academy"
              className="h-[420px] w-full object-cover lg:h-[520px]"
            />
          </div>

          <div
            className="floaty absolute -bottom-10 -right-2 w-[46%] overflow-hidden rounded-[1.25rem] sm:right-6"
            style={{ border: "6px solid var(--sand)", boxShadow: "0 30px 60px -34px rgba(8,46,41,.55)" }}
          >
            <SmartImage
              src={aboutImages.secondary}
              fallback={aboutImages.secondaryFallback}
              alt="Campus learning spaces"
              className="h-[190px] w-full object-cover"
            />
          </div>

          <div
            className="absolute -left-4 top-8 hidden rounded-2xl px-6 py-5 lg:block"
            style={{ background: "var(--teal-800)" }}
          >
            <p className="font-display text-[2rem] leading-none" style={{ color: "var(--gold-200)" }}>
              1985
            </p>
            <p className="mt-1 text-[0.7rem] tracking-[0.16em] uppercase" style={{ color: "rgba(251,247,240,.65)" }}>
              KPR legacy since
            </p>
          </div>
        </div>

        {/* Copy */}
        <div data-reveal="">
          <Eyebrow>About the Academy</Eyebrow>
          <h2
            className="font-display mt-5 text-[2.1rem] leading-[1.1] tracking-tight sm:text-[2.9rem]"
            style={{ color: "var(--teal-900)", fontWeight: 400 }}
          >
            A few words about<br />
            <em style={{ color: "var(--gold)" }}>Growing by Giving</em>
          </h2>

          <p className="mt-7 text-[1.02rem] leading-relaxed" style={{ color: "var(--muted-ink)" }}>
            An institution founded by a visionary with an unwavering belief that life’s highest purpose is
            not only to take, but to give. At KPR, the philosophy of <strong style={{ color: "var(--teal-800)" }}>‘Growing by Giving’</strong>{" "}
            is the cornerstone of our leadership and the guiding principle behind every step we take —
            shaping minds, nurturing values, and inspiring a legacy of excellence.
          </p>

          <div className="mt-9 grid gap-3 sm:grid-cols-2">
            {aboutValues.map((v) => (
              <div
                key={v}
                className="flex items-center gap-3 rounded-xl bg-white/70 px-4 py-3.5"
                style={{ border: "1px solid rgba(11,59,54,.08)" }}
              >
                <span
                  className="grid h-6 w-6 shrink-0 place-items-center rounded-full"
                  style={{ background: "var(--teal-700)", color: "#fff" }}
                >
                  <Check size={13} strokeWidth={3} />
                </span>
                <span className="text-[0.88rem] font-medium" style={{ color: "var(--teal-800)" }}>
                  {v}
                </span>
              </div>
            ))}
          </div>

          <Link
            to="/about"
            className="group mt-10 inline-flex items-center gap-3 rounded-full px-7 py-3.5 text-[0.86rem] font-semibold"
            style={{ background: "var(--teal-800)", color: "#FBF7F0", transition: "background .3s ease" }}
            onMouseEnter={(e) => (e.currentTarget.style.background = "var(--teal-600)")}
            onMouseLeave={(e) => (e.currentTarget.style.background = "var(--teal-800)")}
          >
            Read More
            <ArrowRight size={16} className="group-hover:translate-x-1" style={{ transition: "transform .3s ease" }} />
          </Link>
        </div>
      </div>
    </section>
  );
}
